import React, { useEffect, useState } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr'
import StaffModal from './Modal/StaffModal'
import { useTranslation } from "react-i18next";

import './Staff.css'

const Staff = () => {
    const { t } = useTranslation();

    const [staffList, setStaffList] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [editingStaff, setEditingStaff] = useState(null);

    const getAuthHeaders = () => {
        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) xsrfToken = xsrfToken.split('=')[1];

        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) token = token.split('=')[1];

        return {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
            'Bearer': decodeURIComponent(token),
            'Accept': 'application/json'
        };
    };

    const fetchStaff = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/staff`, {
                method: 'GET',
                headers: getAuthHeaders(),
                credentials: 'include',
            });
            if (res.status === 200) {
                const data = await res.json();
                setStaffList(Array.isArray(data) ? data : (data.data || []));
            } else {
                console.error('Staff fetch failed:', res.status);
            }
        } catch (error) {
            console.error('Staff fetch error:', error);
            alert(t('staff.error_fetch'));
        }
    };

    useEffect(() => {
        fetchStaff();
    }, []);

    const handleAdd = () => {
        setEditingStaff(null);
        setModalIsOpen(true);
    };

    const handleEdit = (staff) => {
        setEditingStaff(staff);
        setModalIsOpen(true);
    };

    const handleDelete = async (staff) => {
        if (!window.confirm(t('staff.confirm_delete'))) return;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/staff/${staff.id}`, {
                method: 'DELETE',
                headers: getAuthHeaders(),
                credentials: 'include',
            });
            if (res.status === 200) {
                alert(t('staff.deleted'));
                fetchStaff();
            } else {
                alert(t('staff.error_delete'));
            }
        } catch (error) {
            console.error('Staff delete error:', error);
            alert(t('staff.error_delete'));
        }
    };

    const handleSave = async (payload, staffId) => {
        try {
            let url, method;
            if (staffId) {
                url = `${process.env.REACT_APP_API_URL}/api/staff/${staffId}`;
                method = 'POST';
            } else {
                url = `${process.env.REACT_APP_API_URL}/api/staff`;
                method = 'POST';
            }

            const res = await fetch(url, {
                method,
                headers: getAuthHeaders(),
                credentials: 'include',
                body: JSON.stringify(payload),
            });

            if (res.status === 200 || res.status === 201) {
                alert(staffId ? t('staff.updated') : t('staff.created'));
                setModalIsOpen(false);
                setEditingStaff(null);
                fetchStaff();
            } else {
                const data = await res.json().catch(() => ({}));
                const errorMsg = data.message || (staffId ? t('staff.error_update') : t('staff.error_create'));
                alert(errorMsg);
            }
        } catch (error) {
            console.error('Staff save error:', error);
            alert(staffId ? t('staff.error_update') : t('staff.error_create'));
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setEditingStaff(null);
    };

    return (
        <>
            <Header />
            <SideMenu />
            <div className="staff-list">
                <div className="staff-list-title">{t('staff.title')}</div>
                <button className="staff-list-add-button" onClick={handleAdd}>{t('staff.add')}</button>
                <div className='clearfix'></div>
                <div className="staff-list-content">
                    <table className="staff-list-content-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>{t('staff.name')}</th>
                                <th>{t('staff.login_id')}</th>
                                <th>{t('staff.role')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {staffList.length > 0 ? (
                                staffList.map((staff, index) => (
                                    <Tr key={staff.id || index} staff={staff} onEdit={handleEdit} onDelete={handleDelete} />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="staff-list-empty">{t('staff.empty')}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <StaffModal
                isOpen={modalIsOpen}
                onClose={closeModal}
                onSave={handleSave}
                staff={editingStaff}
            />
        </>
    )
}

export default Staff
